/* Scripts propios de la tienda. Vanilla, sin librerias. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada --- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.getAttribute('data-mt-delay') || '0', 10);
        setTimeout(function () { el.classList.add('mt-visible'); }, d);
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Cifras animadas --- */
  function initCifras() {
    var els = document.querySelectorAll('[data-mt-contador]:not([data-mt-listo])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.setAttribute('data-mt-listo', '1');
        el.textContent = el.getAttribute('data-mt-pre') + el.getAttribute('data-mt-contador') + el.getAttribute('data-mt-post');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        el.setAttribute('data-mt-listo', '1');
        var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var pre = el.getAttribute('data-mt-pre') || '';
        var post = el.getAttribute('data-mt-post') || '';
        var dur = 1500, t0 = null;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
          el.textContent = pre + v.toLocaleString('es-PY') + post;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Barra de stock --- */
  function initStock() {
    var els = document.querySelectorAll('[data-mt-stock]:not([data-mt-listo])');
    if (!els.length) return;
    els.forEach(function (el) {
      el.setAttribute('data-mt-listo', '1');
      var pct = el.getAttribute('data-mt-stock');
      if (reduce) { el.style.width = pct + '%'; return; }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            setTimeout(function () { e.target.style.width = pct + '%'; }, 200);
          });
        }, { threshold: 0.5 });
        io.observe(el);
      } else {
        el.style.width = pct + '%';
      }
    });
  }

  /* --- Duplicar contenido de marquesinas para bucle infinito --- */
  function initMarquesinas() {
    document.querySelectorAll('[data-mt-marquesina]:not([data-mt-listo])').forEach(function (pista) {
      pista.setAttribute('data-mt-listo', '1');
      var grupo = pista.firstElementChild;
      if (!grupo) return;
      pista.appendChild(grupo.cloneNode(true));
    });
  }

  function initTodo() {
    initReveal();
    initCifras();
    initStock();
    initMarquesinas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }

  /* Re-inicializar dentro del editor de Shopify */
  document.addEventListener('shopify:section:load', initTodo);
  document.addEventListener('shopify:section:select', initTodo);
})();

/* ---------- Hero rotativo ----------
   Cambia de destacado cada X segundos. Se detiene si el visitante pasa el
   mouse por encima o si toca un punto, para no cambiarle la pagina mientras
   esta leyendo. */
(function () {
  function initHero(hero) {
    if (hero.getAttribute('data-mt-hero-listo')) return;
    hero.setAttribute('data-mt-hero-listo', '1');

    var slides = hero.querySelectorAll('.mt-hero__slide');
    if (slides.length < 2) return;

    var puntos = hero.querySelectorAll('.mt-hero__punto');
    var segundos = parseInt(hero.getAttribute('data-mt-rotar'), 10) || 7;
    var actual = 0;
    var reloj = null;

    function mostrar(i) {
      actual = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('mt-hero__slide--activo', n === actual); });
      puntos.forEach(function (p, n) { p.classList.toggle('mt-activo', n === actual); });
    }
    function arrancar() {
      parar();
      reloj = setInterval(function () { mostrar(actual + 1); }, segundos * 1000);
    }
    function parar() { if (reloj) { clearInterval(reloj); reloj = null; } }

    puntos.forEach(function (p) {
      p.addEventListener('click', function () {
        mostrar(parseInt(p.getAttribute('data-mt-ir'), 10) || 0);
        parar();
      });
    });
    hero.addEventListener('mouseenter', parar);
    hero.addEventListener('mouseleave', arrancar);

    var lento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!lento) arrancar();
  }

  /* En el celular no hay puntos que valgan: se cambia de producto arrastrando
     con el dedo, que es lo que la gente intenta hacer sin pensar.
     Solo cuenta el gesto horizontal: si el dedo va hacia abajo, es que está
     bajando por la página y no hay que robarle ese movimiento. */
  function initDedo(hero) {
    if (hero.hasAttribute('data-mt-dedo')) return;
    hero.setAttribute('data-mt-dedo', '');
    var x0 = 0, y0 = 0, movido = false;

    hero.addEventListener('touchstart', function (ev) {
      var t = ev.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY; movido = false;
    }, { passive: true });

    hero.addEventListener('touchmove', function (ev) {
      var t = ev.changedTouches[0];
      if (Math.abs(t.clientX - x0) > 12 && Math.abs(t.clientX - x0) > Math.abs(t.clientY - y0)) {
        movido = true;
      }
    }, { passive: true });

    hero.addEventListener('touchend', function (ev) {
      var t = ev.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      // 45 px de recorrido y que sea claramente horizontal.
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      var puntos = hero.querySelectorAll('[data-mt-ir]');
      if (puntos.length < 2) return;
      var actual = 0;
      hero.querySelectorAll('[data-mt-slide]').forEach(function (s, i) {
        if (s.classList.contains('mt-hero__slide--activo')) actual = i;
      });
      var destino = dx < 0 ? actual + 1 : actual - 1;
      if (destino < 0) destino = puntos.length - 1;
      if (destino >= puntos.length) destino = 0;
      puntos[destino].click();
    }, { passive: true });

    // Arrastrar la foto no debe abrir la ficha: solo un toque limpio.
    hero.querySelectorAll('[data-mt-slide]').forEach(function (s) {
      s.addEventListener('click', function (ev) { if (movido) ev.preventDefault(); });
    });
  }

  function initTodos() {
    document.querySelectorAll('[data-mt-hero]').forEach(function (h) { initHero(h); initDedo(h); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodos);
  else initTodos();
  document.addEventListener('shopify:section:load', initTodos);
})();


/* ---------- Carruseles de producto ----------
   Las flechas mueven de a una pantalla entera de tarjetas, nunca de a media.
   "Ver los N" no cambia de pagina: convierte el carrusel en rejilla aca mismo.
   En el movil no hay flechas: se arrastra con el dedo. */
(function () {
  'use strict';

  function initCarrusel(sec) {
    var pista = sec.querySelector('[data-mt-prods]');
    if (!pista || !pista.classList.contains('mt-prods--carrusel')) return;
    if (pista.hasAttribute('data-mt-carrusel-listo')) return;
    pista.setAttribute('data-mt-carrusel-listo', '');

    var flechas = sec.querySelector('[data-mt-flechas]');
    var abrir = sec.querySelector('[data-mt-abrir]');
    var botones = flechas ? [].slice.call(flechas.querySelectorAll('[data-mt-ir]')) : [];

    function paso() {
      var t = pista.querySelector('.mt-card:not([hidden])');
      if (!t) return pista.clientWidth;
      var est = getComputedStyle(pista);
      var gap = parseFloat(est.columnGap || est.gap) || 0;
      var ancho = t.getBoundingClientRect().width + gap;
      // Cuantas tarjetas entran enteras en lo que se ve.
      var cuantas = Math.max(1, Math.round(pista.clientWidth / ancho));
      return ancho * cuantas;
    }

    function pintarFlechas() {
      if (!flechas) return;
      var hayDeSobra = pista.scrollWidth > pista.clientWidth + 2;
      flechas.hidden = !hayDeSobra || !pista.classList.contains('mt-prods--carrusel');
      if (flechas.hidden) return;
      botones.forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-mt-ir'), 10);
        b.disabled = dir < 0
          ? pista.scrollLeft <= 2
          : pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 2;
      });
    }

    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        pista.scrollBy({ left: parseInt(b.getAttribute('data-mt-ir'), 10) * paso(), behavior: 'smooth' });
      });
    });
    pista.addEventListener('scroll', pintarFlechas, { passive: true });
    window.addEventListener('resize', pintarFlechas);

    if (abrir) {
      abrir.addEventListener('click', function () {
        var abierto = !pista.classList.contains('mt-prods--carrusel');
        // Abierto = rejilla con todo a la vista. Cerrado = carrusel.
        pista.classList.toggle('mt-prods--carrusel', abierto);
        abrir.textContent = abrir.getAttribute(abierto ? 'data-mt-txt-abrir' : 'data-mt-txt-cerrar');
        if (abierto) { pista.scrollLeft = 0; }
        pintarFlechas();
      });
    }

    pintarFlechas();
    // Las fotos entran tarde y cambian el ancho: se repasa cuando cargan.
    setTimeout(pintarFlechas, 900);
    setTimeout(pintarFlechas, 2500);
  }

  function initTodos() {
    [].slice.call(document.querySelectorAll('.mt-productos')).forEach(initCarrusel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodos);
  else initTodos();
  document.addEventListener('shopify:section:load', initTodos);
})();

/* ---------- Buscador y categorias ----------
   La tienda es UNA sola pagina.
   - Las categorias no navegan: bajan hasta el bloque de esa categoria.
   - El buscador no navega: esconde las tarjetas que no coinciden en TODOS los
     bloques a la vez, y esconde entero el bloque que se queda sin nada. */
(function () {
  'use strict';

  function normal(t) {
    // Sin tildes y en minusculas: quien escribe "serum" tiene que encontrar
    // "Serum", y quien escribe "depilacion" tiene que encontrar "Depilacion".
    return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function init() {
    var secciones = [].slice.call(document.querySelectorAll('.mt-productos'));
    if (!secciones.length) return;
    if (document.body.hasAttribute('data-mt-buscador-listo')) return;
    document.body.setAttribute('data-mt-buscador-listo', '');

    var form = document.querySelector('[data-mt-buscador]');
    var cats = [].slice.call(document.querySelectorAll('[data-mt-filtro]'));
    var todas = [].slice.call(document.querySelectorAll('.mt-productos .mt-card'));

    todas.forEach(function (c) {
      var t = (c.querySelector('.mt-card__titulo') || {}).textContent || '';
      var g = (c.querySelector('.mt-card__categoria') || {}).textContent || '';
      var d = (c.querySelector('.mt-card__desc') || {}).textContent || '';
      c.mtTexto = normal(t + ' ' + g + ' ' + d + ' ' + (c.getAttribute('data-mt-rutinas') || ''));
    });

    var estado = document.querySelector('[data-mt-estado]');
    var estadoTxt = estado ? estado.querySelector('[data-mt-estado-txt]') : null;
    var verTodo = estado ? estado.querySelector('[data-mt-ver-todo]') : null;
    var caja = form ? form.querySelector('input[type="search"]') : null;
    var limpiar = form ? form.querySelector('[data-mt-buscador-limpiar]') : null;
    var secCats = document.querySelector('.mt-cats-sec');

    function buscar(texto) {
      var t = normal(String(texto || '').trim());
      var limpio = String(texto || '').trim();
      var visiblesTotal = 0;

      secciones.forEach(function (sec) {
        var vistas = 0;
        [].slice.call(sec.querySelectorAll('.mt-card')).forEach(function (c) {
          var entra = !t || c.mtTexto.indexOf(t) !== -1;
          c.hidden = !entra;
          if (entra) vistas++;
        });
        // En el catalogo cada producto vive en un solo bloque, asi que se
        // suman todos y el numero es el de verdad.
        visiblesTotal += vistas;
        // Con busqueda puesta, el bloque que se queda vacio desaparece entero.
        sec.hidden = !!t && vistas === 0;
      });

      // Mientras se busca, la tira de categorias no pinta nada.
      if (secCats) secCats.hidden = !!t;

      if (limpiar) limpiar.hidden = !t;
      if (estado) {
        estado.hidden = !t;
        if (t && estadoTxt) {
          estadoTxt.textContent = visiblesTotal === 0
            ? 'No encontramos nada para "' + limpio + '"'
            : (visiblesTotal === 1 ? 'Mostrando 1 producto' : 'Mostrando ' + visiblesTotal + ' productos') +
              ' para "' + limpio + '"';
        }
      }
      // Las flechas de los carruseles dependen de cuantas tarjetas quedan.
      window.dispatchEvent(new Event('resize'));
    }

    // El filtrado en vivo solo tiene sentido donde estan todos los productos.
    // En el inicio hay ocho destacados: escribir ahi y ver "1 resultado" seria
    // mentira. Desde el inicio, el buscador manda al catalogo.
    var esCatalogo = !!document.querySelector('[data-mt-es-catalogo]');
    if (form && caja && esCatalogo) {
      form.addEventListener('submit', function (ev) { ev.preventDefault(); caja.blur(); });
      caja.addEventListener('input', function () { buscar(caja.value); });
      if (limpiar) {
        limpiar.addEventListener('click', function () { caja.value = ''; buscar(''); caja.focus(); });
      }
    }
    if (verTodo) {
      verTodo.addEventListener('click', function () {
        if (caja) caja.value = '';
        buscar('');
        var arriba = document.querySelector('[data-mt-rejilla]');
        if (arriba) window.scrollTo({ top: arriba.getBoundingClientRect().top + window.pageYOffset - 130, behavior: 'smooth' });
      });
    }

    // Las categorias bajan hasta su bloque, no cambian de pagina.
    function saltarA(ancla) {
      if (!ancla) return false;
      var destino = document.getElementById('bloque-' + ancla);
      if (!destino) return false;
      window.scrollTo({ top: destino.getBoundingClientRect().top + window.pageYOffset - 88, behavior: 'smooth' });
      cats.forEach(function (a) {
        a.classList.toggle('mt-cat--activa', a.getAttribute('data-mt-filtro') === ancla);
      });
      try { window.history.replaceState(null, '', '#' + ancla); } catch (e) {}
      return true;
    }

    cats.forEach(function (a) {
      a.addEventListener('click', function (ev) {
        if (saltarA(a.getAttribute('data-mt-filtro'))) ev.preventDefault();
      });
    });

    var todosBtn = document.querySelector('[data-mt-todos]');
    if (todosBtn) {
      todosBtn.addEventListener('click', function () {
        var arriba = document.querySelector('[data-mt-rejilla]');
        cats.forEach(function (a) { a.classList.remove('mt-cat--activa'); });
        if (arriba) window.scrollTo({ top: arriba.getBoundingClientRect().top + window.pageYOffset - 130, behavior: 'smooth' });
        try { window.history.replaceState(null, '', window.location.pathname); } catch (e) {}
      });
    }

    // Si se llega con ?q=algo (por ejemplo buscando desde una ficha), la
    // portada abre ya filtrada y con la palabra escrita en la caja.
    try {
      var pedido = esCatalogo ? new URLSearchParams(window.location.search).get('q') : null;
      if (pedido) {
        if (caja) caja.value = pedido;
        buscar(pedido);
      }
    } catch (e) {}

    // Al abrir con #rostro (por ejemplo desde el pie) baja solo hasta ahi.
    var h = (window.location.hash || '').replace('#', '');
    if (h) setTimeout(function () { saltarA(h); }, 400);
    window.addEventListener('hashchange', function () {
      saltarA((window.location.hash || '').replace('#', ''));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---------- El titulo de la pestaña cuando te vas ----------
   Si la persona se va a otra pestaña, el titulo va cambiando para que se
   acuerde de volver. Al volver, el titulo original vuelve solo.
   Es el UNICO sitio de toda la tienda donde se usan emojis. */
(function () {
  'use strict';
  var FRASES = ['Volvé 👀', 'Estás a un clic', 'Tu carrito te espera 🐼'];
  var original = document.title;
  var reloj = null;
  var i = 0;

  function arrancar() {
    if (reloj) return;
    i = 0;
    document.title = FRASES[0];
    reloj = setInterval(function () {
      i = (i + 1) % FRASES.length;
      document.title = FRASES[i];
    }, 2200);
  }
  function parar() {
    if (reloj) { clearInterval(reloj); reloj = null; }
    document.title = original;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { arrancar(); } else { parar(); }
  });
  window.addEventListener('blur', arrancar);
  window.addEventListener('focus', parar);
})();

/* ---------- Pestanas del pie de la ficha ----------
   Descripcion, envios y garantia. Sin libreria: son tres botones que
   encienden su panel y apagan los otros. Si el navegador no ejecuta el
   guion, el primer panel se ve igual y los otros quedan ocultos, que es
   preferible a que se vean los tres apilados. */
(function () {
  function initPestanas(caja) {
    if (caja.dataset.mtListo === '1') return;
    caja.dataset.mtListo = '1';
    var botones = caja.querySelectorAll('.mt-tabs__btn');
    if (!botones.length) return;

    Array.prototype.forEach.call(botones, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(botones, function (otro) {
          var panel = document.getElementById(otro.getAttribute('aria-controls'));
          var activo = otro === b;
          otro.classList.toggle('mt-activa', activo);
          otro.setAttribute('aria-selected', activo ? 'true' : 'false');
          if (panel) panel.hidden = !activo;
        });
      });
    });
  }

  function initTodas() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mt-tabs]'), initPestanas);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodas);
  else initTodas();
  document.addEventListener('shopify:section:load', initTodas);
})();


/* ---------- El WhatsApp, con el mensaje ya escrito ----------
   A todos los enlaces a wa.me se les cuelga un texto que dice desde que
   pagina escriben y la direccion exacta. Asi no hay que preguntarles
   "de donde salis". Se hace aca, en un solo sitio, para que valga tambien
   para los enlaces que se agreguen manana. */
(function () {
  function initWhatsApp() {
    var texto = window.mtWa;
    if (!texto) return;
    var mensaje = texto + '\n' + window.location.href;
    var enlaces = document.querySelectorAll('a[href*="wa.me/"], a[href*="api.whatsapp.com"]');
    Array.prototype.forEach.call(enlaces, function (a) {
      if (a.dataset.mtWaListo === '1') return;
      a.dataset.mtWaListo = '1';
      var href = a.getAttribute('href') || '';
      if (href.indexOf('text=') !== -1) return;      // ya trae el suyo, no se pisa
      a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'text=' + encodeURIComponent(mensaje));
      // Sale de la tienda: siempre en otra pestana, para no perder donde estaba.
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWhatsApp);
  else initWhatsApp();
  document.addEventListener('shopify:section:load', initWhatsApp);
})();

/* ---------- La zona de envio, elegida sola ----------
   El formulario de EasySell muestra las DOS opciones (Asuncion/Central y
   Interior) a proposito: si solo se viera la de Asuncion, el que vive en
   Encarnacion piensa que no le mandamos.

   Pero elegir no es cosa del cliente: la zona ya la dice el departamento que
   carga mas abajo. Asi que en cuanto lo elige, marcamos nosotros la que le
   corresponde. Sin esto, alguien del interior puede dejar marcada la de
   Gs. 25.000 y nos comemos la diferencia en cada envio.

   Las opciones se reconocen por su texto, no por su posicion: si manana se
   agrega una tercera tarifa, esto sigue funcionando. */
(function () {
  'use strict';

  // Los dos departamentos que entran en la tarifa barata, como los escribe Dropi.
  var CERCA = ['ASUNCION', 'CENTRAL'];

  function sinTildes(t) {
    return (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();
  }

  function marcarZona(dep) {
    var modal = document.querySelector('.es-modal');
    if (!modal) return;
    var radios = modal.querySelectorAll('input[type="radio"].es-radio');
    if (radios.length < 2) return;   // con una sola opcion no hay nada que elegir

    var cerca = CERCA.indexOf(sinTildes(dep)) !== -1;

    for (var i = 0; i < radios.length; i++) {
      var fila = radios[i].closest('label') || radios[i].parentElement.parentElement;
      var texto = sinTildes(fila ? fila.textContent : '');
      var esLaDeCerca = texto.indexOf('GRAN ASUNCION') !== -1;
      var esLaDelInterior = texto.indexOf('INTERIOR') !== -1;
      var corresponde = cerca ? esLaDeCerca : esLaDelInterior;

      if (corresponde && !radios[i].checked) {
        radios[i].click();
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  /* El desplegable de departamento nace despues, cuando se abre el
     formulario, asi que se escucha en el documento y no en el elemento. */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.id !== 'es-province') return;
    var dep = el.options[el.selectedIndex] ? el.options[el.selectedIndex].textContent : '';
    // EasySell recalcula el envio al cambiar el departamento: se le da tiempo
    // a que repinte las opciones antes de marcar la que toca.
    setTimeout(function () { marcarZona(dep); }, 700);
    setTimeout(function () { marcarZona(dep); }, 1800);
  });
})();

/* ---------------------------------------------------------------------------
   El campo de correo del formulario de EasySell viene como type="text", asi
   que el navegador no comprueba el formato: "asdf" pasaba igual. Y sin un
   correo bien escrito el cliente no recibe la confirmacion del pedido, que es
   justo para lo que se lo pedimos.

   Se le pone type="email" e inputmode, que ademas hace que en el celular
   aparezca el teclado con la arroba.
   ------------------------------------------------------------------------- */
(function () {
  function arreglarCorreo() {
    var c = document.querySelector('input[name="email"].es-input');
    if (!c || c.dataset.mtCorreo) return;
    c.dataset.mtCorreo = '1';
    c.type = 'email';
    c.setAttribute('inputmode', 'email');
    c.setAttribute('autocomplete', 'email');
  }

  /* El formulario nace cuando se abre el popup, no con la pagina. */
  new MutationObserver(arreglarCorreo).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  arreglarCorreo();
})();
